import { render, staticRenderFns } from "./popup-layer.vue?vue&type=template&id=36c4bb4e"
import script from "./popup-layer.vue?vue&type=script&lang=js"
export * from "./popup-layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports